export { default as GDMButton } from './GDMButton';

export type { GDMButtonComponent, GDMButtonProps } from './GDMButton.type';
